import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useDeleteSchema() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: (id: number) => 
      api.admin.pages.deleteSchema({ params: { id } }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'page-schemas'] });
      toaster.create({
        title: "Schema deleted successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useDeleteSchema] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while deleting the schema.';
      
      toaster.create({
        title: "Failed to delete schema",
        description: errorMessage,
        type: "error",
      });
    },
  });
}

